import { motion } from 'framer-motion';

export default function Logo() {
  return (
    <motion.button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      whileHover={{ opacity: 0.85 }}
      transition={{ duration: 0.2 }}
      className="flex items-center gap-3 bg-transparent border-none cursor-pointer"
      aria-label="Radiance Financial, back to top"
    >
      <svg width="26" height="26" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <rect width="32" height="32" fill="#0A0A0A"/>
        <path d="M8 6h8.5c3.5 0 5.5 1.8 5.5 4.8 0 2.2-1.1 3.8-2.9 4.5L23 26h-3.8l-3.5-10H11v10H8V6zm3 2.8v5.4h5.2c1.7 0 2.8-.9 2.8-2.7 0-1.8-1.1-2.7-2.8-2.7H11z" fill="#FF6B00"/>
      </svg>
      <span
        className="font-sans text-label tracking-label uppercase text-text-label"
        style={{ letterSpacing: '0.22em' }}
      >
        Radiance Financial
      </span>
    </motion.button>
  );
}